import React, { Children, memo } from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
export function WhatIncludes() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 30
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  return <section id="incluye" className="w-full bg-gray-50 py-20 px-4" data-id="element-193">
      <div className="max-w-7xl mx-auto" data-id="element-194">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-195">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4" data-id="element-196">
            O que inclui o Mega Pacote?
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-197">
            Tudo organizado por etapa e ano escolar — alinhado à BNCC.
          </p>
          <p className="text-2xl font-bold text-red-700 mt-4" data-id="element-198">
            📚 12 Tomos em formato digital PDF
          </p>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true
      }} className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-12" data-id="element-199">
          {/* Fundamental I */}
          <motion.div variants={itemVariants} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-2xl transition-shadow duration-300" data-id="element-200">
            <div className="p-8" data-id="element-201">
              <div className="mb-6" data-id="element-202">
                <img src="https://cdn.magicpatterns.com/uploads/gL1BLd9sqCvFpVWmcsyLEj/heylloyd-image-1771971443562.png" alt="Ensino Fundamental I - Sala de aula com crianças" className="w-full h-64 object-cover rounded-lg" data-id="element-203" />
              </div>

              <div className="mb-6" data-id="element-204">
                <span className="text-sm font-bold text-red-700 uppercase tracking-wide" data-id="element-205">
                  🎨 ENSINO FUNDAMENTAL I
                </span>
                <h3 className="text-2xl font-bold text-gray-900 mt-2 mb-2" data-id="element-206">
                  Anos Iniciais
                </h3>
                <p className="text-gray-600 font-semibold" data-id="element-207">
                  Tomos 01 ao 06 | 1º ao 5º Ano
                </p>
              </div>

              <ul className="space-y-3 mb-6" data-id="element-208">
                <li className="flex items-start text-sm" data-id="element-209">
                  <CheckIcon className="h-5 w-5 text-green-600 mr-2 mt-0.5 flex-shrink-0" data-id="element-210" />
                  <span className="text-gray-700" data-id="element-211">
                    <strong data-id="element-212">Tomo 01</strong> — Alfabetização Visual (Ponto,
                    Linha e Cor)
                  </span>
                </li>
                <li className="flex items-start text-sm" data-id="element-213">
                  <CheckIcon className="h-5 w-5 text-green-600 mr-2 mt-0.5 flex-shrink-0" data-id="element-214" />
                  <span className="text-gray-700" data-id="element-215">
                    <strong data-id="element-216">Tomo 02</strong> — Formas, Texturas e Espaço
                    Criativo
                  </span>
                </li>
                <li className="flex items-start text-sm" data-id="element-217">
                  <CheckIcon className="h-5 w-5 text-green-600 mr-2 mt-0.5 flex-shrink-0" data-id="element-218" />
                  <span className="text-gray-700" data-id="element-219">
                    <strong data-id="element-220">Tomo 03</strong> — Identidade, Folclore e Cultura
                    Popular
                  </span>
                </li>
                <li className="flex items-start text-sm" data-id="element-221">
                  <CheckIcon className="h-5 w-5 text-green-600 mr-2 mt-0.5 flex-shrink-0" data-id="element-222" />
                  <span className="text-gray-700" data-id="element-223">
                    <strong data-id="element-224">Tomo 04</strong> — Patrimônio e Arte Regional
                  </span>
                </li>
                <li className="flex items-start text-sm" data-id="element-225">
                  <CheckIcon className="h-5 w-5 text-green-600 mr-2 mt-0.5 flex-shrink-0" data-id="element-226" />
                  <span className="text-gray-700" data-id="element-227">
                    <strong data-id="element-228">Tomo 05</strong> — Grandes Mestres do Brasil
                  </span>
                </li>
                <li className="flex items-start text-sm" data-id="element-229">
                  <CheckIcon className="h-5 w-5 text-green-600 mr-2 mt-0.5 flex-shrink-0" data-id="element-230" />
                  <span className="text-gray-700" data-id="element-231">
                    <strong data-id="element-232">Tomo 06</strong> — Projetos e Datas Comemorativas
                  </span>
                </li>
              </ul>

              <div className="border-t border-gray-200 pt-4" data-id="element-233">
                <ul className="space-y-2 text-sm text-gray-600" data-id="element-234">
                  <li data-id="element-235">• Atividades lúdicas prontas para imprimir</li>
                  <li data-id="element-236">• Planos de aula passo a passo</li>
                  <li data-id="element-237">• Códigos BNCC em cada atividade</li>
                  <li data-id="element-238">• Avaliações e fichas de observação</li>
                </ul>
              </div>
            </div>
          </motion.div>

          {/* Fundamental II & Médio */}
          <motion.div variants={itemVariants} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-2xl transition-shadow duration-300" data-id="element-239">
            <div className="p-8" data-id="element-240">
              <div className="mb-6" data-id="element-241">
                <img src="https://cdn.magicpatterns.com/uploads/qNtcQQQFkFA8fVZo8Xhpqg/heylloyd-image-1771971825295.png" alt="Ensino Médio - Adolescentes em atividade artística" className="w-full h-64 object-cover rounded-lg" data-id="element-242" />
              </div>

              <div className="mb-6" data-id="element-243">
                <span className="text-sm font-bold text-red-700 uppercase tracking-wide" data-id="element-244">
                  🎨 FUNDAMENTAL II & MÉDIO
                </span>
                <h3 className="text-2xl font-bold text-gray-900 mt-2 mb-2" data-id="element-245">
                  Anos Finais
                </h3>
                <p className="text-gray-600 font-semibold" data-id="element-246">
                  Tomos 07 ao 12 | 6º Ano ao Ensino Médio
                </p>
              </div>

              <ul className="space-y-3 mb-6" data-id="element-247">
                <li className="flex items-start text-sm" data-id="element-248">
                  <CheckIcon className="h-5 w-5 text-green-600 mr-2 mt-0.5 flex-shrink-0" data-id="element-249" />
                  <span className="text-gray-700" data-id="element-250">
                    <strong data-id="element-251">Tomo 07</strong> — Arte Urbana, Graffiti e Estética
                    das Ruas
                  </span>
                </li>
                <li className="flex items-start text-sm" data-id="element-252">
                  <CheckIcon className="h-5 w-5 text-green-600 mr-2 mt-0.5 flex-shrink-0" data-id="element-253" />
                  <span className="text-gray-700" data-id="element-254">
                    <strong data-id="element-255">Tomo 08</strong> — Cultura Digital, Fotografia e
                    Novas Mídias
                  </span>
                </li>
                <li className="flex items-start text-sm" data-id="element-256">
                  <CheckIcon className="h-5 w-5 text-green-600 mr-2 mt-0.5 flex-shrink-0" data-id="element-257" />
                  <span className="text-gray-700" data-id="element-258">
                    <strong data-id="element-259">Tomo 09</strong> — Arte Conceitual e Crítica Social
                  </span>
                </li>
                <li className="flex items-start text-sm" data-id="element-260">
                  <CheckIcon className="h-5 w-5 text-green-600 mr-2 mt-0.5 flex-shrink-0" data-id="element-261" />
                  <span className="text-gray-700" data-id="element-262">
                    <strong data-id="element-263">Tomo 10</strong> — História da Arte Brasileira (Foco
                    ENEM)
                  </span>
                </li>
                <li className="flex items-start text-sm" data-id="element-264">
                  <CheckIcon className="h-5 w-5 text-green-600 mr-2 mt-0.5 flex-shrink-0" data-id="element-265" />
                  <span className="text-gray-700" data-id="element-266">
                    <strong data-id="element-267">Tomo 11</strong> — Design e Indústrias Criativas
                  </span>
                </li>
                <li className="flex items-start text-sm" data-id="element-268">
                  <CheckIcon className="h-5 w-5 text-green-600 mr-2 mt-0.5 flex-shrink-0" data-id="element-269" />
                  <span className="text-gray-700" data-id="element-270">
                    <strong data-id="element-271">Tomo 12</strong> — Projeto de Vida e Portfólio do
                    Aluno
                  </span>
                </li>
              </ul>

              <div className="border-t border-gray-200 pt-4" data-id="element-272">
                <ul className="space-y-2 text-sm text-gray-600" data-id="element-273">
                  <li data-id="element-274">• Conteúdo alinhado ao novo Ensino Médio</li>
                  <li data-id="element-275">• Foco em protagonismo juvenil</li>
                  <li data-id="element-276">• Projetos interdisciplinares prontos</li>
                  <li data-id="element-277">• Material para análise de imagens (ENEM)</li>
                </ul>
              </div>
            </div>
          </motion.div>
        </motion.div>

        {/* Bônus com Imagem */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="mb-12" data-id="element-278">
          <div className="relative rounded-xl overflow-hidden shadow-2xl" data-id="element-279">
            <img src="https://cdn.magicpatterns.com/uploads/j1NnW4kTrUCZ63tT6K7utH/heylloyd-image-1771972462888.png" alt="Bônus Exclusivos - Materiais extras" className="w-full h-64 md:h-80 object-cover" data-id="element-280" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent flex items-end" data-id="element-281">
              <div className="p-8 w-full" data-id="element-282">
                <h3 className="text-3xl md:text-4xl font-bold text-white mb-2" data-id="element-283">
                  🎁 Bônus Exclusivos
                </h3>
                <p className="text-lg md:text-xl text-white/90" data-id="element-284">
                  3 recursos extras incluídos nos dois planos
                </p>
              </div>
            </div>
          </div>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true
      }} className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-285">
          <motion.div variants={itemVariants} className="bg-gradient-to-br from-amber-50 to-orange-50 rounded-xl p-6 border-2 border-amber-200 hover:shadow-lg transition-shadow duration-300" data-id="element-286">
            <div className="text-4xl mb-3" data-id="element-287">🎯</div>
            <h4 className="text-lg font-bold text-gray-900 mb-2" data-id="element-288">Bônus #1</h4>
            <p className="text-sm font-semibold text-gray-800 mb-2" data-id="element-289">
              Aula de Artes em 10 Minutos
            </p>
            <p className="text-sm text-gray-600" data-id="element-290">
              Roteiro Anti-Estresse para conduzir qualquer aula com segurança e
              clareza
            </p>
          </motion.div>

          <motion.div variants={itemVariants} className="bg-gradient-to-br from-amber-50 to-orange-50 rounded-xl p-6 border-2 border-amber-200 hover:shadow-lg transition-shadow duration-300" data-id="element-291">
            <div className="text-4xl mb-3" data-id="element-292">📋</div>
            <h4 className="text-lg font-bold text-gray-900 mb-2" data-id="element-293">Bônus #2</h4>
            <p className="text-sm font-semibold text-gray-800 mb-2" data-id="element-294">
              Banco de Avaliação Inteligente
            </p>
            <p className="text-sm text-gray-600" data-id="element-295">
              Rubricas + Pareceres prontos para avaliar sem travar e sem
              subjetividade
            </p>
          </motion.div>

          <motion.div variants={itemVariants} className="bg-gradient-to-br from-amber-50 to-orange-50 rounded-xl p-6 border-2 border-amber-200 hover:shadow-lg transition-shadow duration-300" data-id="element-296">
            <div className="text-4xl mb-3" data-id="element-297">🎨</div>
            <h4 className="text-lg font-bold text-gray-900 mb-2" data-id="element-298">Bônus #3</h4>
            <p className="text-sm font-semibold text-gray-800 mb-2" data-id="element-299">
              Ateliê Econômico
            </p>
            <p className="text-sm text-gray-600" data-id="element-300">
              Guia de Materiais Acessíveis + Substituições Inteligentes para
              qualquer escola
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}